import Media from './Media.js'
export default Media
